import { CropDashboardState, ICropDashboardData } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import { applyExtraReducer } from "../../weather";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { createThunk, DashboardReqBodyWithDate } from "./selector";
import { dashboardURL } from "@utils/utils";


const initialState: CropDashboardState = {
  data: {
    totalGeoZoneHa: 0,
    cultivatedArea: []
  },
  isApiLoading: true,
  apiError: undefined
}

const fetchDashboardCrops =
    createThunk<ICropDashboardData, DashboardQueryParams, DashboardReqBodyWithDate>()(
        { url: dashboardURL('cropsCultivatedAreaByDate'), method: "POST" },
        (payload, url) => ({
          url,
          data: {
              cropRotationIds: payload.cropRotationIds || [],
              date: payload.date
          }
        })
    )

const cropsSlice = createSlice({
  name: 'cropsDashboardSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    applyExtraReducer(builder, fetchDashboardCrops)
  },
})

export const actions = { ...cropsSlice.actions, fetchDashboardCrops }
export default cropsSlice.reducer